<!-- src/views/DashboardView.vue -->

<template>
  <div class="row">
    <div class="col-xxl-6">
      <!--begin::Engage widget 10-->
      <div class="card card-flush h-md-100">
        <!--begin::Body-->
        <div
          class="card-body d-flex flex-column justify-content-between mt-9 bgi-no-repeat bgi-size-cover bgi-position-x-center pb-0"
        >
          <div class="mb-10">
            <div class="col-xl-12 features">
              <div class="d-flex h-100 align-items-center">
                <div
                  class="w-100 d-flex flex-column flex-center rounded-3 bg-light bg-opacity-75 p-2"
                >
                  <div class="mb-7 text-center">
                    <h1 class="text-dark mb-1 fw-bolder">أكاديميا</h1>
                    <div class="text-gray-400 fw-semibold mb-1"><br />تعلم بلا حدود</div>
                  </div>
                  <img
                    class="mx-auto h-100px h-lg-100px theme-light-show"
                    style="width: 120px; height: 120px !important"
                    src="assets/img/2.png"
                    alt=""
                  />

                  <div class="w-100 mb-10">
                    <div class="d-flex align-items-center mb-5 box">
                      <span class="fw-semibold fs-4 text-gray-800 flex-grow-1 pe-3">
                        دعم فني مستمر
                      </span>
                      <span class="svg-icon svg-icon-1 svg-icon-success">
                        <i class="fa-solid fa-check-circle"></i>
                      </span>
                    </div>
                    <div class="d-flex align-items-center mb-5 box">
                      <span class="fw-semibold fs-4 text-gray-800 flex-grow-1 pe-3">
                        طرق دفع أمنة
                      </span>
                      <span class="svg-icon svg-icon-1 svg-icon-success">
                        <i class="fa-solid fa-check-circle"></i>
                      </span>
                    </div>
                    <div class="d-flex align-items-center mb-5 box">
                      <span class="fw-semibold fs-4 text-gray-800 flex-grow-1 pe-3">
                        باقات مخصصة</span
                      >
                      <span class="svg-icon svg-icon-1 svg-icon-success">
                        <i class="fa-solid fa-check-circle"></i>
                      </span>
                    </div>
                    <div class="d-flex align-items-center mb-5 box">
                      <span class="fw-semibold fs-4 text-gray-800 flex-grow-1 pe-3"
                        >دورات مباشرة</span
                      >
                      <span class="svg-icon svg-icon-1 svg-icon-success">
                        <i class="fa-solid fa-check-circle"></i>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--end::Body-->
      </div>
      <!--end::Engage widget 10-->
    </div>

    <div class="col-xxl-6 info-box">
      <div class="card card-flush h-md-100">
        <div
          class="card-body d-flex flex-column mt-9 bgi-no-repeat bgi-size-cover bgi-position-x-center pb-0"
        >
          <img
            class="mx-auto h-150px h-lg-200px theme-light-show"
            src="assets/img/s1.png"
            alt=""
          />
          <img
            style="border: 10px solid #a3a3a314; border-radius: 10px; padding: 10px"
            class="mx-auto h-150px h-lg-200px theme-dark-show"
            src="assets/img/s1.png"
            alt=""
          />
          <div class="mt-20">
            <div class="fs-2 fw-bold text-gray-800 text-center mb-13">
              <span class="me-2"
                >تعلم بلا حدود مع أكاديميا إبدأ بتطوير نفسك و تصفح مجموعة كبيرة من الدورات
                في عدة مجالات في
                <br />
                <span class="position-relative d-inline-block text-success">
                  <a
                    href="../../demo1/dist/pages/user-profile/overview.html"
                    class="text-success opacity-75-hover"
                  >
                    أكاديما</a
                  >
                  <span
                    class="position-absolute opacity-15 bottom-0 start-0 border-4 border-success border-bottom w-100"
                  ></span> </span
              ></span>
              وانطلق
            </div>
            <span class="fw-semibold text-center fs-6 mb-8 d-block opacity-75">
              تطبيق أكاديميا يوفر تعليم عالي الجودة لطلاب المدارس الإعدادية والثانوية
              والجامعة. بفضل ميزاته المميزة ونهجه التكنولوجي، يمكن للطلاب الوصول إلى محتوى
              تدريب متميز في أي وقت ومن أي مكان.
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { apiUrl } from "@/utils/api";

export default {
  name: "infoDetails",
  data() {
    return {
      banners: [],
    };
  },
  async mounted() {},
  methods: {},
};
</script>
<style scoped>
/* Carousel container */
.carousel {
  height: 350px; /* ⬅️ ارتفاع كامل للcarousel */
}

/* Carousel cells */
.carousel-cell {
  width: calc(100% - 10px);
  margin-right: 10px;
  height: 100%; /* ⬅️ يملأ ارتفاع الcarousel */
  display: flex;
  align-items: center;
  justify-content: center;
}

@media (min-width: 992px) {
  .carousel-cell {
    width: calc(50% - 10px);
    margin-right: 10px;
    height: 100%;
  }
}

.carousel-cell {
  cursor: pointer;
}

/* Banner image */
.banner-img {
  width: 95%;
  height: 100%;
  object-fit: cover;
  border-radius: 8px;
  transition: all 0.3s ease;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}

.carousel-cell:hover .banner-img {
  transform: scale(1.03);
  box-shadow: 0 8px 14px rgba(0, 0, 0, 0.15);
}
</style>
